import styled from "styled-components";

export const SCardUploadPhoto = styled.label<{isMobile?: boolean }>`
  height: 510px;
  width: 375px;
  border-radius: 12px;
  background-color: #fee2e2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;


  @media screen and (max-width: 460px) {
    width: 300px;
  }
`;

export const CardPhoto = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 10px;
  object-fit: cover;
  transition: all 0.3s;

`;
